"use strict";

exports.__esModule = true;
exports.useFormRepeatItem = useFormRepeatItem;

var _react = require("react");

var _hooks = require("@bydesign-ui/hooks");

var _useForm = require("./useForm");

var _useFormScope = require("./useFormScope");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function useFormRepeatItem(options) {
  var form = (0, _useForm.useForm)();
  var scope = (0, _useFormScope.useFormScope)();
  var repeat = form.getField(scope.getValue().id);

  if (repeat && !repeat.isRepeat()) {
    throw new Error('RepeatItem must use under Repeat');
  }

  var field = options.field;

  var _useReactiveState = (0, _hooks.useReactiveState)(function () {
    return repeat.getRepeatGroup(field);
  }, options, function (ins) {
    return ins.getGroupInfo();
  }),
      instance = _useReactiveState[0],
      state = _useReactiveState[1];

  var onRemove = (0, _react.useCallback)(function () {
    return repeat.removeRepeatItem(field);
  }, []);
  var onAppend = (0, _react.useCallback)(function (data) {
    return repeat.insertAfterRepeatItem(field, data);
  }, []);
  var onPrepend = (0, _react.useCallback)(function (data) {
    return repeat.insertBeforeRepeatItem(field, data);
  }, []);
  return _extends({
    instance: instance,
    onRemove: onRemove,
    onAppend: onAppend,
    onPrepend: onPrepend
  }, state);
}